import React, { Component } from 'react'
import PropTypes from 'prop-types'
import InfoButton from '../../../../components/ui/buttons/InfoButton'

const questionPropTypeShape = PropTypes.shape({
  meaningDetail: PropTypes.string.isRequired,
  meaningId: PropTypes.string.isRequired,
  categoryId: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
})

class PersonalityQuestion extends Component {
  static propTypes = {
    question: PropTypes.shape({
      a: questionPropTypeShape,
      b: questionPropTypeShape,
    }).isRequired,
    onSelectAnswer: PropTypes.func.isRequired,
  }

  render() {
    const { question, onSelectAnswer } = this.props
    return (
      <div style={{ padding: 10 }}>
        <h3 className="text-center">
          Which describes you best? <InfoButton content="Stuck? Sometimes both answers will describe you (it's part of the test). Pick the best answer and keep going!" styles={{fontSize: 14}} />
        </h3>
        <div className="row" style={{ marginTop: 30 }}>
          <div className="col-md-12 d-flex justify-content-center">
            <button className="btn btn-lg btn-outline-primary btn-break" onClick={() => onSelectAnswer('a')}>
              {question.a.content}
            </button>
          </div>
          <div className="col-md-12 d-flex justify-content-center mt-3">
            <button className="btn btn-lg btn-outline-primary btn-break" onClick={() => onSelectAnswer('b')}>
              {question.b.content}
            </button>
          </div>
        </div>
      </div>
    )
  }
}

export default PersonalityQuestion



// WEBPACK FOOTER //
// ./src/routes/authenticated/PersonalityAssessment/components/PersonalityQuestion.js